import React from 'react';
import Logo from './Logo';
import { DEMO_EMAIL, LEGAL_ENTITY, NAV_LINKS } from './brand';

const LEGAL = [
  { href: '/privacy', label: 'Privacy Policy' },
  { href: '/terms', label: 'Terms & Conditions' },
  { href: '/eula', label: 'EULA' },
];

export default function LandingFooter({ onLogin, onRequestDemo }) {
  return (
    <footer className="border-t border-white/10 bg-slate-950">
      <div className="mx-auto max-w-6xl safe-area-x py-14 sm:px-6 lg:px-8">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <Logo />
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-400">
              Club management built around how rowing actually works &mdash; lineups, blades, meters,
              splits and the river.
            </p>
            <a
              href={`mailto:${DEMO_EMAIL}`}
              className="mt-4 inline-block text-sm font-medium text-sky-400 underline-offset-4 hover:underline"
            >
              {DEMO_EMAIL}
            </a>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-wider text-slate-500">
              Product
            </h3>
            <ul className="mt-4 space-y-2.5">
              {NAV_LINKS.map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="text-sm text-slate-400 hover:text-white">
                    {link.label}
                  </a>
                </li>
              ))}
              <li>
                <button onClick={onLogin} className="text-sm text-slate-400 hover:text-white">
                  Sign in
                </button>
              </li>
              <li>
                <button onClick={onRequestDemo} className="text-sm text-slate-400 hover:text-white">
                  Request a demo
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-wider text-slate-500">Legal</h3>
            <ul className="mt-4 space-y-2.5">
              {LEGAL.map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="text-sm text-slate-400 hover:text-white">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 sm:flex-row">
          <p className="text-xs text-slate-500">
            &copy; {new Date().getFullYear()} {LEGAL_ENTITY}. All rights reserved.
          </p>
          <p className="text-xs text-slate-600">Made for boathouses.</p>
        </div>
      </div>
    </footer>
  );
}
